import { Notification } from '../types/Notification';

const API_URL = `${import.meta.env.VITE_DATA_API_URL}/notification/banner`;
export const DEFAULT_TIMEOUT = 60000;

const fetchWithTimeout = (url: string, options: RequestInit, timeout = DEFAULT_TIMEOUT): Promise<Response> => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Request timed out')), timeout);
    fetch(url, options)
      .then(response => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch(error => {
        clearTimeout(timer);
        reject(error);
      });
  });
};

export const fetchNotifications = async (token: string, timeout = DEFAULT_TIMEOUT): Promise<Notification[]> => {
  try {
    const response = await fetchWithTimeout(
      API_URL,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      timeout,
    );

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const data: { body: Notification[] } = await response.json();
    return data.body;
  } catch (error) {
    throw new Error('Failed to fetch notifications');
  }
};
